import React from 'react';
import ReactDOM from 'react-dom';
import NvChartSettingsForm from './partials/NvChartSettingsForm';
import { initialValues } from "./partials/settings-form/default-values";

export default function loadCommands(editor, options) {
  const {Commands} = editor;
  const {
    modalTitle,
    componentKey,
    componentCommandName,
    formElementID
  } = options;

  const instance = {
    componentKey,
    run(editor, sender, opts = {}) {
      this.editor = editor;
      this.options = opts;
      this.target = opts.target || editor.getSelected();
      const {target} = this;

      const componentData = target.get(componentKey) || initialValues;
      let content = `<div id="${formElementID}"></div>`;

      editor.Modal
        .open({title: modalTitle, content})
        .getModel()
        .once('change:open', () => editor.stopCommand(this.id));

      const reactRootElement = document.getElementById(formElementID);

      ReactDOM.render(<NvChartSettingsForm
        defaultValues={componentData}
        submitHandler={(formValues) => {
          const {editor, target} = this;

          target.addAttributes({'settings': formValues});
          target.set(componentKey, formValues);

          editor.Modal.close();
        }}/>, reactRootElement);
    },
    stop() {
      editor.Modal.close();
    }
  };

  Commands.add(componentCommandName, instance);
}
